import { render } from "./WebinarOverview.vue?vue&type=template&id=2f00a78c"
import script from "./WebinarOverview.vue?vue&type=script&lang=js"
export * from "./WebinarOverview.vue?vue&type=script&lang=js"

import "./WebinarOverview.vue?vue&type=style&index=0&id=2f00a78c&lang=scss"

import exportComponent from "/Users/gardener/OpenideProjects/Navigator_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__